import { render, staticRenderFns } from "./MonthlySalary.vue?vue&type=template&id=72caf312&"
import script from "./MonthlySalary.vue?vue&type=script&lang=js&"
export * from "./MonthlySalary.vue?vue&type=script&lang=js&"
import style0 from "./MonthlySalary.vue?vue&type=style&index=0&id=72caf312&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports